/* eslint-disable import/prefer-default-export */
import { provideLocal } from '@vueuse/core';
import { usePageData } from '@composables/usePageData';
import { useProduct } from '../../product/composables/useProduct';
import {
  PRODUCT_FLAGS_REPOSITORY,
  PRODUCT_TOP_LEVEL_CATEGORY_FLAGS_REPOSITORY,
  PRODUCT_FEATURE_ELIGIBILITY_REPOSITORY,
} from '../../product/constants';

export const useFlagsProvide = () => {
  const { flags: { common: commonFlags, groupByProducts: groupByProductsFlags } } = usePageData();
  // common product flags - same for all products (i.e. master and member)
  const { topLevelCategoryFlags } = commonFlags;
  // get flags by product Id
  const { productId } = useProduct();
  const { productFlags, featureEligibilityFlags } = groupByProductsFlags?.[productId] || { productFlags: {}, featureEligibilityFlags: {} };

  provideLocal(PRODUCT_FLAGS_REPOSITORY, productFlags);
  provideLocal(PRODUCT_TOP_LEVEL_CATEGORY_FLAGS_REPOSITORY, topLevelCategoryFlags);
  provideLocal(PRODUCT_FEATURE_ELIGIBILITY_REPOSITORY, featureEligibilityFlags);
};
